<template>
  <Modal :closable="false" v-model="openForm" fullscreen footer-hide>
    <div style="display: flex;">
      <div>
        <Button @click="exportData" type="primary">导出</Button>
        <Button @click="destroyIframe()">关闭</Button>
      </div>
      <div style="margin-left: auto;">
        <slot name="btn"></slot>
      </div>
    </div>
    <div ref="iframWrap" style="width: 100%;height: 100%;"></div>
  </Modal>
</template>
<script>
export default {
  data() {
    return {
      openForm: false,
      base: null,
      //base: "",
      url: ""
    };
  },
  methods: {
    open(url, scan) {
      this.base = "https://view.officeapps.live.com/op/view.aspx?src=";
      this.url = url;

      if (scan == true) {
        let iframe = document.createElement("iframe");
        iframe.width = "100%";
        iframe.height = "100%";
        iframe.src = this.base + this.url;
        this.iframe = iframe;
        this.$refs.iframWrap.appendChild(iframe);

        //推出后，帮我写一个销毁ifram的方法
        this.openForm = true;
      } else {
        this.exportData(scan);
      }
    },
    exportData(scan) {
      // this.url 是你的 Excel 文件地址
      const link = document.createElement("a");
      link.href = this.url;

      // 关键：download 属性告诉浏览器这是下载，不是打开
      // 可以自定义文件名，例如 link.download = '庐陵数据.xlsx';
      link.download = ""; // 留空则使用原文件名

      // 模拟点击
      document.body.appendChild(link);
      link.click();

      // 清理DOM
      document.body.removeChild(link);
    },
    exportData3() {
      //this.url是一个excel文件庐陵
      //有的浏览器会重新打开标签页
      //如何出处理
      window.open(this.url);
    },

    //如果是文件流，这么些
    exportData2() {
      // 1. 请求文件流（axios/fetch）
      fetch(this.url, {
        method: "GET",
        responseType: "blob"
      })
        .then(res => res.blob())
        .then(blob => {
          // 2. 创建下载链接
          const url = window.URL.createObjectURL(blob);
          const link = document.createElement("a");
          link.href = url;
          link.download = "庐陵数据.xlsx"; // 自定义文件名
          link.click();
          // 释放URL对象
          window.URL.revokeObjectURL(url);
        })
        .catch(err => {
          console.error("下载失败", err);
          alert("文件下载失败，请重试");
        });
    },
    destroyIframe() {
      this.$refs.iframWrap.removeChild(this.iframe);
      this.openForm = false;
      this.base = null;
      this.url = null;
    }
  }
};
</script>



// WEBPACK FOOTER //
// ../common/src/components/officeScan.vue